export const BRANDS_PER_COL = 4;
export const PAGE_SIZE_OPTIONS = [25, 50, 75, 100];

export const TOOLS = {
  PRODUCT_MANUALS: 'Product Manuals',
  SALES_GUIDANCE: 'Sales Guidance',
  PRODUCT_COMPARISON: 'Product Comparison',
  WARRANTY_REG: 'Warranty Registration',
  WARRANTY_CLAIM: 'Warranty Claim',
  DEALER_SUCCESS: 'Dealer Success'
};

export const SALES_PAGE = 'sales-page';
export const LEARNING_PAGE = 'learning-page';
export const FLEX_CENTERED = 'flex-centered';
export const MYAGIREP = 'my-agi-rep';

export const FOOTER_FULL = 'footer-full';
export const FOOTER_LEFT = 'footer-left';
